export class FonteDadosVersaoDetalhes {
    versaoatual: String;
    ultimaversao: String;
    microservico: ParametroNomeMicroServicoVersao;
}

export enum MicroServico {
    CONVERSOR = 'Conversor',
    EXTRATOR = 'Extrator',
    IRIS = 'Iris',
    PRISMA = 'Prisma'
  }

export enum ParametroNomeMicroServicoVersao {
    ULTIMA_VERSAO_CONVERSOR = 'ultimaVersaoConversor',
    ULTIMA_VERSAO_EXTRATOR = 'ultimaVersaoExtrator',
    ULTIMA_VERSAO_IRIS =  'ultimaVersaoIris',
    ULTIMA_VERSAO_PRISMA =  'ultimaVersaoPrisma'
  }
